import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-25d06172"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = { key: 1 }
const _hoisted_3 = ["src"]
const _hoisted_4 = { key: 1 }
const _hoisted_5 = ["src"]

import { ref } from 'vue';
import { RouteRecordRaw } from 'vue-router';
import { useRoute } from 'vue-router'


function setup(__props) {

const props = __props

const onlyOne = ref()
const isShow = (item: RouteRecordRaw) => {
  if(item.meta?.alwaysShow) {
    return false
  }
  const childrenArr = item.children ?? []
  const arr: RouteRecordRaw[] = []
  childrenArr.forEach((el: RouteRecordRaw) => {
    if (!el.meta?.hidden) {
      arr.push(el)
    }
  });
  if (arr.length === 0) {
    onlyOne.value = item
    return true
  } else if (arr.length === 1) {
    onlyOne.value = arr[0]
    return true
  }
  return false
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_item_menu = _resolveComponent("item-menu", true)!
  const _component_a_sub_menu = _resolveComponent("a-sub-menu")!

  return (!__props.item.children)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        style: _normalizeStyle({display: __props.item.meta?.displayRoute ? 'none' : ''})
      }, [
        (!__props.item.meta?.hidden)
          ? (_openBlock(), _createBlock(_component_a_menu_item, {
              key: `${__props.basePath}`
            }, _createSlots({
              default: _withCtx(() => [
                _createVNode(_component_router_link, { to: __props.item }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(__props.item.meta?.title || ''), 1)
                  ]),
                  _: 1
                }, 8, ["to"])
              ]),
              _: 2
            }, [
              (__props.item.meta?.icon)
                ? {
                    name: "icon",
                    fn: _withCtx(() => [
                      _createElementVNode("img", {
                        src: __props.item.meta?.icon,
                        alt: "",
                        width: "20"
                      }, null, 8, _hoisted_1)
                    ])
                  }
                : undefined
            ]), 1024))
          : _createCommentVNode("", true)
      ], 4))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        (isShow(__props.item))
          ? (_openBlock(), _createBlock(_component_a_menu_item, {
              key: `${__props.basePath}`,
              style: _normalizeStyle( {background: 'none',display: __props.item.meta?.displayRoute ? 'none' : ''})
            }, _createSlots({
              default: _withCtx(() => [
                _createVNode(_component_router_link, { to: onlyOne.value }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(onlyOne.value.meta?.title || ''), 1)
                  ]),
                  _: 1
                }, 8, ["to"])
              ]),
              _: 2
            }, [
              (onlyOne.value.meta?.icon)
                ? {
                    name: "icon",
                    fn: _withCtx(() => [
                      _createElementVNode("img", {
                        src: onlyOne.value.meta?.icon,
                        alt: "",
                        width: "20"
                      }, null, 8, _hoisted_3)
                    ])
                  }
                : undefined
            ]), 1032, ["style"]))
          : (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_a_sub_menu, {
                key: `${__props.basePath}`
              }, _createSlots({
                title: _withCtx(() => [
                  _createTextVNode(_toDisplayString(__props.item.meta?.title), 1)
                ]),
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.item.children, (child, index) => {
                    return (_openBlock(), _createElementBlock("div", { key: index }, [
                      _createVNode(_component_item_menu, {
                        item: child,
                        basePath: `${__props.basePath}/${child.path}`,
                        style: {"margin-left":"8px"}
                      }, null, 8, ["item", "basePath"])
                    ]))
                  }), 128))
                ]),
                _: 2
              }, [
                (__props.item.meta?.icon)
                  ? {
                      name: "icon",
                      fn: _withCtx(() => [
                        _createElementVNode("img", {
                          src: __props.item.meta?.icon,
                          alt: "",
                          width: "20"
                        }, null, 8, _hoisted_5)
                      ])
                    }
                  : undefined
              ]), 1024)
            ]))
      ]))
}
}


const __default__ = {
  name: 'ItemMenu.vue'
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: ['item', 'basePath'],
  setup})